import React, { useState, useEffect, useRef } from 'react';
import {
  Modal, ModalHeader, ModalBody, ModalFooter, Button,
  FormGroup, Label, Input
} from 'reactstrap';
import { supabase } from '../../supabaseClient';
import {
  FiUploadCloud, FiTrash2, FiEdit2, FiImage, FiPlus, FiSun, FiHome, FiMonitor
} from 'react-icons/fi';

const STORAGE_BUCKET = 'gallery';

const GalleryManager = () => {
  const [images, setImages]           = useState([]);
  const [loading, setLoading]         = useState(true);
  const [modal, setModal]             = useState(false);
  const [editModal, setEditModal]     = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [files, setFiles]             = useState([]);
  const [previews, setPreviews]       = useState([]);
  const [uploading, setUploading]     = useState(false);
  const [hoveredId, setHoveredId]     = useState(null);
  const [apiError, setApiError]       = useState('');
  const [title, setTitle]             = useState('');
  const [category, setCategory]       = useState('All');
  const [uploadCategory, setUploadCategory] = useState('Newborn');
  const fileRef = useRef();

const fetchImages = async () => {
  try {
    setLoading(true);

    const { data, error } = await supabase
      .from('photos')
      .select('*')
      .order('created_at', { ascending: false });

    if (error) throw error;

    setImages(data);

  } catch (err) {
    setApiError(err.message);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => { fetchImages(); }, []);

  const handleFileChange = (e) => {
    const picked = Array.from(e.target.files);
    setFiles(picked);
    setPreviews(picked.map(f => URL.createObjectURL(f)));
  };

const handleUpload = async () => {
  if (!files.length) return;

  try {
    setUploading(true);

    for (const file of files) {
      const fileName = `${Date.now()}-${file.name}`;

      const { error: uploadError } = await supabase.storage
        .from(STORAGE_BUCKET)
        .upload(fileName, file);

      if (uploadError) throw uploadError;

      const { data } = supabase.storage
        .from(STORAGE_BUCKET)
        .getPublicUrl(fileName);

      const { error: dbError } = await supabase
        .from('photos')
        .insert([
          {
            title: title || file.name,
            image_url: data.publicUrl,
            category: uploadCategory
          }
        ]);

      if (dbError) throw dbError;
    }

    fetchImages();

    setModal(false);
    setFiles([]);
    setPreviews([]);
    setTitle('');
    setUploadCategory('Newborn');

  } catch (err) {
    console.error(err);
    setApiError(err.message);
  } finally {
    setUploading(false);
  }
};

const handleReplace = async () => {
  if (!files.length) return;

  try {
    setUploading(true);

    const file = files[0];
    const fileName = `${Date.now()}-${file.name}`;

    const { error: uploadError } = await supabase.storage
      .from(STORAGE_BUCKET)
      .upload(fileName, file);

    if (uploadError) throw uploadError;

    const { data } = supabase.storage
      .from(STORAGE_BUCKET)
      .getPublicUrl(fileName);

    const { error } = await supabase
      .from('photos')
      .update({
        title: title || selectedItem.title,
        image_url: data.publicUrl,
        category: uploadCategory
      })
      .eq('id', selectedItem.id);

    if (error) throw error;

    fetchImages();

    setEditModal(false);
    setFiles([]);
    setPreviews([]);
    setTitle('');
    setUploadCategory('Newborn');

  } catch (err) {
    setApiError(err.message);
  } finally {
    setUploading(false);
  }
};

const handleDelete = async () => {
  try {
    const { error } = await supabase
      .from('photos')
      .delete()
      .eq('id', selectedItem.id);

    if (error) throw error;

    fetchImages();
    setDeleteModal(false);

  } catch (err) {
    setApiError(err.message);
  }
};

  const openAdd  = () => { setFiles([]); setPreviews([]); setApiError(''); setTitle(''); setUploadCategory('Newborn'); setModal(true); };
  const openEdit = (img) => { setSelectedItem(img); setFiles([]); setPreviews([]); setApiError(''); setTitle(img.title || ''); setUploadCategory(img.category || 'Newborn'); setEditModal(true); };
  const openDel  = (img) => { setSelectedItem(img); setDeleteModal(true); };

  return (
    <div style={s.wrap}>
      <div style={s.hdr}>
        <div>
          <h2 style={s.title}><FiImage style={{ marginRight: 10 }} />Gallery</h2>
          <p style={s.sub}>{images.length} photos · Manage your portfolio</p>
        </div>
        <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={() => setCategory('All')}
            style={{
              padding: '10px 16px',
              borderRadius: 10,
              border: category === 'All' ? '2px solid rgba(124,58,237,0.8)' : '1px solid rgba(255,255,255,0.15)',
              background: category === 'All' ? 'rgba(124,58,237,0.3)' : 'rgba(255,255,255,0.05)',
              color: '#fff',
              fontSize: 14,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              fontWeight: category === 'All' ? 600 : 400
            }}
          >
            <FiImage size={16} /> All
          </button>
          {/* <button
            onClick={() => setCategory('Newborn')}
            style={{
              padding: '10px 16px',
              borderRadius: 10,
              border: category === 'Newborn' ? '2px solid rgba(124,58,237,0.8)' : '1px solid rgba(255,255,255,0.15)',
              background: category === 'Newborn' ? 'rgba(124,58,237,0.3)' : 'rgba(255,255,255,0.05)',
              color: '#fff',
              fontSize: 14,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              fontWeight: category === 'Newborn' ? 600 : 400
            }}
          >
            <FiSun size={16} /> Newborn
          </button> */}
          <button
            onClick={() => setCategory('Indoor')}
            style={{
              padding: '10px 16px',
              borderRadius: 10,
              border: category === 'Indoor' ? '2px solid rgba(124,58,237,0.8)' : '1px solid rgba(255,255,255,0.15)',
              background: category === 'Indoor' ? 'rgba(124,58,237,0.3)' : 'rgba(255,255,255,0.05)',
              color: '#fff',
              fontSize: 14,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              fontWeight: category === 'Indoor' ? 600 : 400
            }}
          >
            <FiHome size={16} /> Indoor
          </button>
          <button
            onClick={() => setCategory('Outdoor')}
            style={{
              padding: '10px 16px',
              borderRadius: 10,
              border: category === 'Outdoor' ? '2px solid rgba(124,58,237,0.8)' : '1px solid rgba(255,255,255,0.15)',
              background: category === 'Outdoor' ? 'rgba(124,58,237,0.3)' : 'rgba(255,255,255,0.05)',
              color: '#fff',
              fontSize: 14,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              fontWeight: category === 'Outdoor' ? 600 : 400
            }}
          >
            <FiMonitor size={16} /> Outdoor
          </button>
          <button style={s.addBtn} onClick={openAdd}>
            <FiPlus size={16} /> Add Photos
          </button>
        </div>
      </div>

      {apiError && (
        <div style={s.errBanner}>⚠ API Error: {apiError}</div>
      )}

      {loading ? (
        <div style={s.center}><span style={s.spinner} /></div>
      ) : images.length === 0 ? (
        <div style={s.empty}>
          <FiImage size={48} style={{ opacity: 0.3, marginBottom: 12 }} />
          <p>No photos yet. Click "Add Photos" to get started.</p>
        </div>
      ) : (
        <div style={s.grid}>
          {images.filter(img => category === 'All' || img.category === category).map(img => (
            <div
              key={img.id}
              style={s.card}
              onMouseEnter={() => setHoveredId(img.id)}
              onMouseLeave={() => setHoveredId(null)}
            >
              <img src={img.image_url} alt={img.title} style={s.img} />
              <div style={{ ...s.overlay, opacity: hoveredId === img.id ? 1 : 0 }}>
                {/* <button style={s.iconBtn} onClick={() => openEdit(img)} title="Replace">
                  <FiEdit2 size={15} />
                </button> */}
                <button style={{ ...s.iconBtn, ...s.delIconBtn }} onClick={() => openDel(img)} title="Delete">
                  <FiTrash2 size={15} />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <Modal isOpen={modal} toggle={() => setModal(false)} centered size="md">
        <ModalHeader toggle={() => setModal(false)}>
          <FiUploadCloud style={{ marginRight: 8 }} />Upload Photos
        </ModalHeader>
        <ModalBody>
          {apiError && <div style={s.modalErr}>⚠ {apiError}</div>}
          {/* <FormGroup>
            <Label for="photo-title" style={{ fontWeight: 600 }}>
              Title <span style={{ color: '#ef4444' }}>*</span>
            </Label>
            <Input
              id="photo-title"
              type="text"
              placeholder="Enter photo title"
              value={title}
              onChange={e => setTitle(e.target.value)}
              style={{ marginBottom: 16 }}
            />
          </FormGroup> */}
          <FormGroup>
            <Label for="photo-category" style={{ fontWeight: 600 }}>
              Category <span style={{ color: '#ef4444' }}>*</span>
            </Label>
            <Input
              id="photo-category"
              type="select"
              value={uploadCategory}
              onChange={e => setUploadCategory(e.target.value)}
              style={{ marginBottom: 16 }}
            >
              {/* <option value="Newborn">Newborn</option> */}
              <option value="">Select Category</option>
              <option value="Indoor">Indoor</option>
              <option value="Outdoor">Outdoor</option>
            </Input>
          </FormGroup>
          <div style={s.dropZone} onClick={() => fileRef.current.click()}>
            <FiUploadCloud size={36} style={{ opacity: 0.5, marginBottom: 8 }} />
            <p style={{ margin: 0, fontWeight: 600 }}>Click to browse files</p>
            <p style={{ margin: '4px 0 0', fontSize: 12, opacity: 0.5 }}>
              JPG, PNG, WEBP — multiple allowed
            </p>
            <input
              ref={fileRef}
              type="file"
              multiple
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
          </div>

          {previews.length > 0 && (
            <div style={s.previewGrid}>
              {previews.map((p, i) => (
                <img key={i} src={p} alt="prev" style={s.prevImg} />
              ))}
            </div>
          )}
          {files.length > 0 && (
            <p style={{ fontSize: 13, opacity: 0.6, marginTop: 8, marginBottom: 0 }}>
              {files.length} file{files.length > 1 ? 's' : ''} selected
            </p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setModal(false)}>Cancel</Button>
          <Button
            color="primary"
            onClick={handleUpload}
            disabled={!files.length || uploading}
            style={{ background: 'linear-gradient(135deg,#7c3aed,#ec4899)', border: 'none' }}
          >
            {uploading ? 'Uploading…' : `Upload ${files.length || ''} Photo${files.length !== 1 ? 's' : ''}`}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={editModal} toggle={() => setEditModal(false)} centered size="md">
        <ModalHeader toggle={() => setEditModal(false)}>
          <FiEdit2 style={{ marginRight: 8 }} />Replace Photo
        </ModalHeader>
        <ModalBody>
          {apiError && <div style={s.modalErr}>⚠ {apiError}</div>}
          {selectedItem && (
            <img
              src={selectedItem.image_url}
              alt={selectedItem.title}
              style={{ width: '100%', borderRadius: 10, marginBottom: 16, maxHeight: 180, objectFit: 'cover' }}
            />
          )}
          <FormGroup>
            <Label for="edit-category" style={{ fontWeight: 600 }}>
              Category
            </Label>
            <Input
              id="edit-category"
              type="select"
              value={uploadCategory}
              onChange={e => setUploadCategory(e.target.value)}
              style={{ marginBottom: 16 }}
            >
              {/* <option value="Newborn">Newborn</option> */}
              <option value="Indoor">Indoor</option>
              <option value="Outdoor">Outdoor</option>
            </Input>
          </FormGroup>
          <div style={s.dropZone} onClick={() => fileRef.current.click()}>
            <FiUploadCloud size={30} style={{ opacity: 0.5, marginBottom: 6 }} />
            <p style={{ margin: 0, fontSize: 14 }}>Select replacement image</p>
            <input
              ref={fileRef}
              type="file"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleFileChange}
            />
          </div>
          {previews[0] && (
            <img src={previews[0]} alt="new" style={{ width: '100%', borderRadius: 10, marginTop: 12, maxHeight: 140, objectFit: 'cover' }} />
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setEditModal(false)}>Cancel</Button>
          <Button color="warning" onClick={handleReplace} disabled={!files.length || uploading}>
            {uploading ? 'Replacing…' : 'Replace Photo'}
          </Button>
        </ModalFooter>
      </Modal>

      <Modal isOpen={deleteModal} toggle={() => setDeleteModal(false)} centered size="sm">
        <ModalHeader toggle={() => setDeleteModal(false)}>
          <FiTrash2 style={{ marginRight: 8, color: '#ef4444' }} />Confirm Delete
        </ModalHeader>
        <ModalBody>
          <p style={{ margin: 0 }}>
            Are you sure you want to permanently delete this photo? This cannot be undone.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={() => setDeleteModal(false)}>Cancel</Button>
          <Button color="danger" onClick={handleDelete}>Delete Photo</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

const s = {
  wrap: { padding: '8px 0' },
  hdr:  { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: 28, flexWrap: 'wrap', gap: 12 },
  title: { fontSize: 22, fontWeight: 700, margin: 0, display: 'flex', alignItems: 'center' },
  sub:   { margin: '4px 0 0', opacity: 0.5, fontSize: 13 },
  addBtn: {
    background: 'linear-gradient(135deg,#7c3aed,#ec4899)',
    color: '#fff', border: 'none', borderRadius: 10,
    padding: '10px 20px', cursor: 'pointer', fontWeight: 600, fontSize: 14,
    display: 'flex', alignItems: 'center', gap: 6,
    boxShadow: '0 4px 16px rgba(124,58,237,0.35)',
    transition: 'transform 0.15s',
  },
  errBanner: {
    background: 'rgba(239,68,68,0.12)',
    border: '1px solid rgba(239,68,68,0.3)',
    borderRadius: 10, padding: '10px 16px',
    color: '#fca5a5', fontSize: 13, marginBottom: 20,
  },
  modalErr: {
    background: 'rgba(239,68,68,0.1)',
    border: '1px solid rgba(239,68,68,0.25)',
    borderRadius: 8, padding: '8px 12px',
    color: '#ef4444', fontSize: 13, marginBottom: 14,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
    gap: 16,
  },
  card: {
    borderRadius: 14, overflow: 'hidden', position: 'relative',
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.08)',
    aspectRatio: '1',
    cursor: 'pointer',
  },
  img: { width: '100%', height: '100%', objectFit: 'cover', display: 'block' },
  overlay: {
    position: 'absolute', inset: 0,
    background: 'rgba(0,0,0,0.55)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    gap: 10, opacity: 0, transition: 'opacity 0.2s',
  },
  iconBtn: {
    background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.2)',
    color: '#fff', borderRadius: 8, padding: '8px 10px', cursor: 'pointer',
    backdropFilter: 'blur(8px)', transition: 'background 0.15s',
  },
  delIconBtn: { background: 'rgba(239,68,68,0.3)', borderColor: 'rgba(239,68,68,0.4)' },
  center: { display: 'flex', justifyContent: 'center', padding: 60 },
  spinner: {
    width: 36, height: 36,
    border: '3px solid rgba(255,255,255,0.1)',
    borderTopColor: '#7c3aed', borderRadius: '50%',
    animation: 'spin 0.7s linear infinite', display: 'inline-block',
  },
  empty: { textAlign: 'center', padding: '60px 20px', opacity: 0.5 },
  dropZone: {
    border: '2px dashed rgba(124,58,237,0.5)',
    borderRadius: 12, padding: '32px 20px',
    textAlign: 'center', cursor: 'pointer',
    transition: 'border-color 0.2s, background 0.2s',
    background: 'rgba(124,58,237,0.05)',
  },
  previewGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(80px,1fr))',
    gap: 8, marginTop: 16,
  },
  prevImg: { width: '100%', aspectRatio: '1', objectFit: 'cover', borderRadius: 8 },
};

export default GalleryManager;
